/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreviewAssignmentConflictsRequestDto
 */
export interface PreviewAssignmentConflictsRequestDto {
    /**
     * Candidate asset ids to check for an existing active plan
     * @type {Array<string>}
     * @memberof PreviewAssignmentConflictsRequestDto
     */
    assetIds: Array<string>;
}

/**
 * Check if a given object implements the PreviewAssignmentConflictsRequestDto interface.
 */
export function instanceOfPreviewAssignmentConflictsRequestDto(value: object): value is PreviewAssignmentConflictsRequestDto {
    if (!('assetIds' in value) || value['assetIds'] === undefined) return false;
    return true;
}

export function PreviewAssignmentConflictsRequestDtoFromJSON(json: any): PreviewAssignmentConflictsRequestDto {
    return PreviewAssignmentConflictsRequestDtoFromJSONTyped(json, false);
}

export function PreviewAssignmentConflictsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreviewAssignmentConflictsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetIds': json['assetIds'],
    };
}

export function PreviewAssignmentConflictsRequestDtoToJSON(json: any): PreviewAssignmentConflictsRequestDto {
    return PreviewAssignmentConflictsRequestDtoToJSONTyped(json, false);
}

export function PreviewAssignmentConflictsRequestDtoToJSONTyped(value?: PreviewAssignmentConflictsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetIds': value['assetIds'],
    };
}

